/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Box, Flex, Image, Text, Tooltip, useDisclosure } from '@chakra-ui/react';

import Icon from '../../../shared/components/Icon';
import { CategoryCard } from '../../Gallery/shared';
import { TextEllipsis } from '../../../shared/components/Typography';
import ActionButton from '../../../shared/components/ActionButton';
import { IBanners } from '../../../shared/services/types/banners';
import { MidiaModal } from './MidiaModal/MidiaModal';
import useStore from '../../../shared/store';

function BannerItem({ item: { id, name, media } }: { item: IBanners }) {
  const selectedMedia = useStore((state) => state.campaigns.selectedMedia);
  const api = useStore((s) => s.api);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOpen = () => {
    api.dispatchSelectedBanner(id, {
      imageUrl: media.imageUrl,
      cupom: media.cupom,
    });
    onOpen();
  };

  return (
    <CategoryCard key={id} overflow="hidden" height="300px">
      <Flex
        margin="18px 0 12px"
        textAlign="start"
        padding="0 12px"
        justifyContent="space-between"
        alignItems="center"
      >
        <Tooltip label={name}>
          <TextEllipsis maxWidth="100%">{name}</TextEllipsis>
        </Tooltip>
        <Box minWidth="max-content" lineHeight="none">
          <ActionButton
            onClick={handleOpen}
            icon={<Icon icon="icon-chevron-double-right" />}
            title="Editar banner"
            aria-label="Editar banner"
          />
        </Box>
      </Flex>

      <MidiaModal isOpen={isOpen} onClose={onClose} imageId={id} />
    </CategoryCard>
  );
}

export default BannerItem;
